<template>
  <a-spin :spinning="confirmLoading">
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="searchQuery" layout="inline">
        <a-row :gutter="24">
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <a-form-item label="测点名称">
              <a-input allow-clear placeholder="请输入测点名称" v-debounce="searchQuery" v-model="queryParam.pointName"></a-input>
            </a-form-item>
          </a-col>
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <a-form-item label="点号">
              <a-input allow-clear placeholder="请输入点号" v-debounce="searchQuery" v-model="queryParam.pointCode"></a-input>
            </a-form-item>
          </a-col>
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
              <a-button @click="searchQuery" icon="search" type="primary">查询</a-button>
              <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table
      :columns="columns"
      :dataSource="dataSource"
      :loading="loading"
      :pagination="ipagination"
      :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
      :scroll="{y:500}"
      @change="handleTableChange"
      bordered
      class="j-table-force-nowrap"
      ref="table"
      rowKey="id"
      size="middle"
    >
      <template slot="htmlSlot" slot-scope="text">
        <div v-html="text"></div>
      </template>
    </a-table>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'


  export default {
    name: 'IotListAll',
    mixins: [JeecgListMixin],
    components: {
    },
    props: {
      deviceData: {
        type: Object,
        default: () => { }
      },
      // 表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      },
      idType: {
        type: String,
        default: ''
      }

    },
    data () {
      return {
        ipagination: {
          current: 1,
          pageSize: 50,
          //   pageSizeOptions: ['10', '20', '50', '100', '200'],
          //   showTotal: (total, range) => {
          //     return range[0] + '-' + range[1] + ' 共' + total + '条'
          //   },
          //   showQuickJumper: true,
          //   showSizeChanger: true,
          //   total: 0
        },
        loading: false,
        /* table选中keys */
        selectedRowKeys: [],
        /* table选中records */
        selectionRows: [],
        dataSource: [],
        isorter: {
          column: 'pointName',
          order: 'asc',
        },
        columns: [
          {
            title: '设备',
            align: 'center',
            dataIndex: 'devId_dictText',
            witdh: 200,
            sorter: true,
          },
          {
            title: '供水流域',
            align: 'center',
            dataIndex: 'devProcessId_dictText',
            witdh: 150,
            sorter: true,
          },
          {
            title: '测点名称',
            align: 'center',
            dataIndex: 'pointName',
            witdh: 250,
            sorter: true,
          },
          {
            title: '点号',
            align: 'center',
            dataIndex: 'pointCode',
            sorter: true,
          },
        ],
        queryParam: {
          pointName: '',
          pointCode: ''
        },
        field: 'id,,,pointName,pointCode',

        model: {
          dataType: 'float32',
          dataSource: 'calc',
          dataCategory: '',
          readonly: '1',
          multi: 1,
          shift: 0,
          trend: ''
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        confirmLoading: false,
        validatorRules: {
          pointName: [
            { required: true, message: '请输入测点名称!' }
          ],
          pointCode: [
            { required: true, message: '请输入点号!' }
          ],
          dataType: [
            { required: true, message: '请输入数据类型!' }
          ],
          dataSource: [
            { required: true, message: '请输入数据来源!' }
          ]
        },
        pointTypeData: [],
        pointTypeTree: [],
        url: {
          getPointTypeData: '/monitor/iotModelPoints/pointType',
          add: '/monitor/iotModelPoints/add',
          edit: '/monitor/iotModelPoints/editBatch',
          queryById: '/monitor/iotModelPoints/queryById',
          list: '/monitor/iotModelPoints/list',

        }
      }
    },

    computed: {
      formDisabled () {
        return this.disabled
      }
    },
    created () {
      // 备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model))
    },
    methods: {
      loadData (arg) {
        if (!this.url.list) {
          this.$message.error('请设置url.list属性!')
          return
        }
        // 加载数据 若传入参数1则加载第一页的内容
        if (arg === 1) {
          this.ipagination.current = 1
        }
        var params = this.getQueryParams();// 查询条件
        if (params.pointCode) {
          params.pointCode = `*${params.pointCode}*`
        }
        this.loading = true;
        getAction(this.url.list, params).then((res) => {
          if (res.success) {
            this.dataSource = res.result.records || res.result
            if (res.result.total) {
              this.ipagination.total = res.result.total
            } else {
              this.ipagination.total = 0
            }
          } else {
            this.$message.warning(res.message)
          }
        }).finally(() => {
          this.loading = false
        })
      },
      onSelectChange (selectedRowKeys, selectionRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectionRows = selectionRows
      },
      add (devId) {
        if (devId) { this.modelDefault.devId = devId }
        this.edit(this.modelDefault)
      },
      edit (record) {
        this.model = Object.assign({}, record)
        this.visible = true
      },
      submitForm () {
        const that = this
        // 触发表单验证
        that.confirmLoading = true
        let method = 'put'
        const params = this.selectionRows.map(item => {
          item[this.idType] = this.deviceData.id
          return item
        })
        httpAction(this.url.edit, params, method).then((res) => {
          if (res.success) {
            that.$message.success(res.message)
            that.$emit('ok')
          } else {
            that.$message.warning(res.message)
          }
        }).finally(() => {
          that.confirmLoading = false
        })
      },
      getPointTypeData () {
        getAction(this.url.getPointTypeData).then((res) => {
          if (res.success) {
            this.pointTypeData = res.result.map(item => {
              item.keyword = item.keyword.replace(/，/g, ',').replace(/\s/g, '')
              item.keyword = item.keyword.split(',')
              return item
            })
            this.setDefaultDataUnit()
          } else {
            this.$message.warning(res.message)
          }
        })
      },
      setDefaultDataUnit () {
        if (this.model.pointName && this.pointTypeData.length > 0) {
          // this.pointTypeData 中找到所有keyword元素在this.model.pointName中存在的元素
          let pointTypeData = this.pointTypeData.filter(item => {
            return item.keyword.some(keyword => {
              return this.model.pointName.indexOf(keyword) > -1
            })
          })
          // 如果pointTypeData中有元素，则设置默认单位
          if (pointTypeData.length > 0) {
            this.model.dataUnit = pointTypeData[0].unit
            this.model.toprange = pointTypeData[0].top_range
            this.model.botrange = pointTypeData[0].bottom_range
          }
        }
      }
    }

  }
</script>
